import type { ComponentProps, ReactNode } from 'react';
import React from 'react';
import { Box, HStack, Text, VStack } from '@skin-seoul/design-system';
interface SectionContainerProps {
  headerTitle?: string;
  children: ReactNode;
  headerRightContent?: ReactNode;
  showTopBorder?: boolean;
  sectionInnerProps?: ComponentProps<typeof VStack>;
}
const SectionContainer = ({
  headerTitle,
  children,
  headerRightContent,
  showTopBorder = true,
  sectionInnerProps
}: SectionContainerProps) => {
  return <Box background="white" position="relative" width="100%" data-sentry-element="Box" data-sentry-component="SectionContainer" data-sentry-source-file="SectionContainer.tsx">
      {showTopBorder && <Box marginX={{
      base: 4,
      tablet: 0
    }} position="absolute" top={0} left={0} right={0} height="0.5px" background="neutral.100" pointerEvents="none" />}

      <VStack alignItems="flex-start" justifyContent="center" paddingX={{
      base: 4,
      tablet: 0
    }} paddingY={5} width="100%" gap={6} {...sectionInnerProps} data-sentry-element="VStack" data-sentry-source-file="SectionContainer.tsx">
        <HStack gap={6} alignItems="center" justifyContent="space-between" width="100%" data-sentry-element="HStack" data-sentry-source-file="SectionContainer.tsx">
          {headerTitle && <Text textStyle={{
          base: 'label.large',
          tablet: 'heading.h6'
        }} fontWeight="medium" color="neutral.800" textAlign="left" whiteSpace="nowrap" letterSpacing={{
          tablet: '-0.4px'
        }}>
              {headerTitle}
            </Text>}
          {headerRightContent}
        </HStack>

        {children}
      </VStack>
    </Box>;
};
export default SectionContainer;